import { mergeResolvers, mergeTypeDefs } from "@graphql-tools/merge";
import { makeExecutableSchema } from "@graphql-tools/schema";
import * as advert from "./advert";
import * as advertising from "./advertising";
import * as attributes from "./attributes";
import * as campaign from "./campaign";
import * as canvas from "./canvas";
import * as chat from "./chat";
import * as common from "./common";
import * as course from "./course";
import * as deviceInfo from "./deviceInfo";
import * as entitlement from "./entitlement";
import * as htmlSnippet from "./htmlSnippet";
import * as idc from "./idc";
import * as information from "./information";
import * as inquiry from "./inquiry";
import * as link from "./link";
import * as meta from "./meta";
import * as order from "./order";
import * as palette from "./palette";
import * as paymentInstruments from "./paymentInstruments";
import * as paymentMethods from "./paymentMethods";
import * as pinManager from "./pinManager";
import * as playback from "./playback";
import * as product from "./product";
import * as purchase from "./purchase";
import * as ranking from "./ranking";
import * as recommend from "./recommend";
import * as right from "./right";
import * as rtoaster from "./rtoaster";
import * as searchConfig from "./searchConfig";
import * as subscribe from "./subscribe";
import * as terms from "./terms";
import * as user from "./user";
import * as voucherCode from "./voucherCode";
import * as watch from "./watch";
import * as webPage from "./webPage";
const schema = makeExecutableSchema({
  typeDefs: mergeTypeDefs([common.typeDef, user.typeDef, deviceInfo.typeDef, meta.typeDef, advert.typeDef, htmlSnippet.typeDef, webPage.typeDef, palette.typeDef, paymentMethods.typeDef, paymentInstruments.typeDef, purchase.typeDef, subscribe.typeDef, watch.typeDef, playback.typeDef, right.typeDef, course.typeDef, product.typeDef, entitlement.typeDef, order.typeDef, terms.typeDef, canvas.typeDef, link.typeDef, idc.typeDef, information.typeDef, attributes.typeDef, ranking.typeDef, recommend.typeDef, voucherCode.typeDef, campaign.typeDef, rtoaster.typeDef, searchConfig.typeDef, pinManager.typeDef, chat.typeDef, advertising.typeDef, inquiry.typeDef]),
  resolvers: mergeResolvers([common.resolvers, user.resolvers, deviceInfo.resolvers, meta.resolvers, advert.resolvers, htmlSnippet.resolvers, webPage.resolvers, palette.resolvers, paymentMethods.resolvers, paymentInstruments.resolvers, purchase.resolvers, subscribe.resolvers, watch.resolvers, playback.resolvers, right.resolvers, course.resolvers, product.resolvers, entitlement.resolvers, order.resolvers, terms.resolvers, canvas.resolvers, link.resolvers, idc.resolvers, information.resolvers, attributes.resolvers, ranking.resolvers, recommend.resolvers, voucherCode.resolvers, campaign.resolvers, rtoaster.resolvers, searchConfig.resolvers, pinManager.resolvers, chat.resolvers, advertising.resolvers, inquiry.resolvers])
});
export default schema;